import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: 'asks',
    loadChildren: () => import('./asks/asks.module').then( m => m.AsksPageModule)
  },
  {
    path: 'scan',
    loadChildren: () => import('./scan/scan.module').then( m => m.ScanPageModule)
  },
  {
    path: 'crea',
    loadChildren: () => import('./crea/crea.module').then( m => m.CreaPageModule)
  },
  {
    path: 'ask',
    loadChildren: () => import('./ask/ask.module').then( m => m.AskPageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
  },
  {
    path: 'confirme-token',
    loadChildren: () => import('./confirme-token/confirme-token.module').then( m => m.ConfirmeTokenPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule)
  },
  {
    path: 'contacts',
    loadChildren: () => import('./contacts/contacts.module').then( m => m.ContactsPageModule)
  },
  {
    path: 'photo-viewer',
    loadChildren: () => import('./Modales/PhotoViewer/photo-viewer/photo-viewer.module').then( m => m.PhotoViewerPageModule)
  },
  {
    path: 'selector',
    loadChildren: () => import('./Modales/Selector/selector/selector.module').then( m => m.SelectorPageModule)
  },
  {
    path: 'filter',
    loadChildren: () => import('./Modales/Filter/filter/filter.module').then( m => m.FilterPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'contact-selector',
    loadChildren: () => import('./Modales/ContactSelector/contact-selector/contact-selector.module').then( m => m.ContactSelectorPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./Modales/Terms/terms/terms.module').then( m => m.TermsPageModule)
  },  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then( m => m.AdminPageModule)
  }






];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
